import React, { ReactElement } from 'react';
import { useParams } from 'react-router-dom';
import Contacts from '../../../../components/contacts/contacts';
import { StrategyContactsService } from '../../../../services/contacts';

function StrategyContacts() : ReactElement {
  const { id } = useParams<{ id: string }>();
  const service = new StrategyContactsService(id || '');

  return (
    <Contacts service={service} />
  );
}

export default StrategyContacts;
